<section class="about-final-cta dingo-section dingo-bg-accent">
  <div class="container">
    <aside class="about-final-card reveal-on-scroll" data-reveal="card">
      <p class="about-kicker">Siguiente paso</p>
      <h2>Construyamos el próximo caso de <span class="highlight-green">éxito de tu marca</span></h2>
      <p>Agenda una sesión de diagnóstico y definamos un plan claro de crecimiento para tu negocio.</p>
      <div class="about-final-actions">
        <a class="dingo-cta-primary" routerLink="/contacto">
          Contactar equipo
          <i class="bi bi-arrow-up-right"></i>
        </a>
        <a class="dingo-cta-secondary" routerLink="/inicio" fragment="casos-exito">
          Ver casos de éxito
          <i class="bi bi-bar-chart-line"></i>
        </a>
      </div>
    </aside>
  </div>
</section>
